import { render } from "./HotNewsList.vue?vue&type=template&id=96f08702&scoped=true"
import script from "./HotNewsList.vue?vue&type=script&lang=js"
export * from "./HotNewsList.vue?vue&type=script&lang=js"

import "./HotNewsList.vue?vue&type=style&index=0&id=96f08702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f08702"]])

export default __exports__